var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0b19cb30-c356-4873-8a0e-168c96b08c29",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 982.24 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2a09c122-c548-4e8e-9f54-0a10997915a4",
    d: "M884.01,97.76h-34.14v-48.62c0-27.1-21.99-49.14-49.09-49.14s-49.09,22.04-49.09,49.14v48.62H228.29v-48.62c0-27.1-21.99-49.14-49.09-49.14s-49.09,22.04-49.09,49.14v48.62h-31.87C43.98,97.76,0,141.74,0,195.99v785.77c0,54.26,43.98,98.23,98.23,98.23h785.77c54.26,0,98.23-43.98,98.23-98.23V195.99c0-54.26-43.98-98.23-98.23-98.23ZM884.01,981.77H98.23V447.04h785.77v534.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2a09c122-c548-4e8e-9f54-0a10997915a4",
    d: "M712.69,922.02c54.23,0,98.21-43.98,98.21-98.18s-43.98-98.23-98.21-98.23-98.23,43.98-98.23,98.23,43.98,98.18,98.23,98.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/TaskIcon.50e2d23a11bd69ee0cd9e48186a9cfaa.svg";
export { ForwardRef as ReactComponent };